var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2.133c.294 0 .533.24.533.534v9.379L11.89 8.69a.534.534 0 0 1 .755.754L8.377 13.71a.534.534 0 0 1-.754 0L3.356 9.445a.533.533 0 1 1 .754-.754l3.357 3.356v-9.38c0-.294.238-.533.533-.533",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;